import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import GlobalConfig from '../../lib/GlobalConfig';
import { IKImage, IKContext } from 'imagekitio-react';
import { useMemo } from 'react';
import { getImageKitUrlForTemplatePreviewThumbnail } from '../../utils/media/imagekit-util';
export const ImageKitWrapper = ({ thumbnailUrl, width, height, }) => {
    const imageKitPublicKey = GlobalConfig.imageKit.IMAGEKIT_PUBLIC_KEY;
    const imagekitUrlEndpoint = GlobalConfig.imageKit.IMAGEKIT_URL_ENDPOINT;
    const imageKitUrl = useMemo(() => getImageKitUrlForTemplatePreviewThumbnail(thumbnailUrl), [thumbnailUrl]);
    let props = {};
    if (width) {
        props = { ...props, width };
    }
    if (height) {
        props = { ...props, height };
    }
    const transformation = [];
    if (width) {
        transformation.push({ width: String(width) });
    }
    return !!imageKitUrl ? (_jsx(IKContext, { publicKey: imageKitPublicKey, urlEndpoint: imagekitUrlEndpoint, children: _jsx(IKImage, { ...props, loading: "lazy", path: imageKitUrl, transformation: transformation }) })) : (_jsx(_Fragment, {}));
};
